import ReactDOMServer from 'react-dom/server';
import * as jsPDF from 'jspdf';
import $ from 'jquery';

class PDFGenerator {
  static renderPDF (html) {
    const staticHtml = ReactDOMServer.renderToStaticMarkup(html);
    console.log(staticHtml);
    const PDF = new jsPDF();
    // PDF.fromHTML(document.getElementsByClassName('ui text container')[0]);

    PDF.fromHTML($('.ui.text.container').get(0), 15, 15, {
      'width': 170, 
      // 'elementHandlers': specialElementHandlers
    });

    PDF.save('test.pdf');
  }
}

export default PDFGenerator;


// WEBPACK FOOTER //
// ./src/components/PDFGenerator.jsx